export const LIGHT_GALLERY_LICENSE_KEY = "39E371D8-BF6A4A6D-A0E5ED38-5573FDF7";
